export default __webpack_public_path__ + "static/media/AverageReactivePowerEC.cf9d90bf.svg";